// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.action-container{display:flex;justify-content:flex-end;margin-top:.5em}`, "",{"version":3,"sources":["webpack://./src/form_components/loading-modal.scss"],"names":[],"mappings":"AAAA,kBACE,YAAA,CACA,wBAAA,CACA,eAAA","sourcesContent":[".action-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
